export const Meetingactive = () => (
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_35_13247)">
      <path
        d="M5.65665 11.2812C5.65665 10.5059 5.02579 9.875 4.2504 9.875C3.47501 9.875 2.84415 10.5059 2.84415 11.2812C2.84415 12.0566 3.47501 12.6875 4.2504 12.6875C5.02579 12.6875 5.65665 12.0566 5.65665 11.2812Z"
        fill="white"
      />
      <path
        d="M9.40665 11.2812C9.40665 10.5059 8.77579 9.875 8.0004 9.875C7.22501 9.875 6.59415 10.5059 6.59415 11.2812C6.59415 12.0566 7.22501 12.6875 8.0004 12.6875C8.77579 12.6875 9.40665 12.0566 9.40665 11.2812Z"
        fill="white"
      />
      <path
        d="M13.1566 11.2812C13.1566 10.5059 12.5258 9.875 11.7504 9.875C10.975 9.875 10.3441 10.5059 10.3441 11.2812C10.3441 12.0566 10.975 12.6875 11.7504 12.6875C12.5258 12.6875 13.1566 12.0566 13.1566 11.2812Z"
        fill="white"
      />
      <path
        d="M12.6879 12.6875H10.8129C10.453 12.6875 10.1244 12.8236 9.8754 13.0468C9.62637 12.8236 9.29776 12.6875 8.9379 12.6875H7.0629C6.70303 12.6875 6.37442 12.8236 6.1254 13.0468C5.87637 12.8236 5.54776 12.6875 5.1879 12.6875H3.3129C2.53751 12.6875 1.90665 13.3184 1.90665 14.0937V16.0312C1.90665 16.2902 2.11649 16.5 2.3754 16.5H13.6254C13.8843 16.5 14.0941 16.2902 14.0941 16.0312V14.0937C14.0941 13.3184 13.4633 12.6875 12.6879 12.6875Z"
        fill="white"
      />
      <path
        d="M3.78165 6.59375C3.78165 5.81836 3.15079 5.1875 2.3754 5.1875C1.60001 5.1875 0.969147 5.81836 0.969147 6.59375C0.969147 7.36914 1.60001 8 2.3754 8C3.15079 8 3.78165 7.36914 3.78165 6.59375Z"
        fill="white"
      />
      <path
        d="M7.53165 6.59375C7.53165 5.81836 6.90079 5.1875 6.1254 5.1875C5.35001 5.1875 4.71915 5.81836 4.71915 6.59375C4.71915 7.36914 5.35001 8 6.1254 8C6.90079 8 7.53165 7.36914 7.53165 6.59375Z"
        fill="white"
      />
      <path
        d="M11.2816 6.59375C11.2816 5.81836 10.6508 5.1875 9.8754 5.1875C9.10001 5.1875 8.46915 5.81836 8.46915 6.59375C8.46915 7.36914 9.10001 8 9.8754 8C10.6508 8 11.2816 7.36914 11.2816 6.59375Z"
        fill="white"
      />
      <path
        d="M15.0629 6.59375C15.0629 6.21594 14.9084 5.86023 14.6278 5.59204C14.355 5.33118 13.9989 5.1875 13.6254 5.1875C12.85 5.1875 12.2191 5.81836 12.2191 6.59375C12.2191 7.36914 12.85 8 13.6254 8C13.9989 8 14.355 7.85632 14.6278 7.59546C14.9084 7.32727 15.0629 6.97156 15.0629 6.59375Z"
        fill="white"
      />
      <path
        d="M14.5941 8H12.6879C12.328 8 11.9994 8.13611 11.7504 8.35925C11.5014 8.13611 11.1728 8 10.8129 8H8.9379C8.57803 8 8.24942 8.13611 8.0004 8.35925C7.75137 8.13611 7.42276 8 7.0629 8H5.1879C4.82803 8 4.49942 8.13611 4.2504 8.35925C4.00137 8.13611 3.67276 8 3.3129 8H1.40665C0.631256 8 0.000396729 8.63086 0.000396729 9.40625V11.2812C0.000396729 11.5402 0.210236 11.75 0.469147 11.75H1.95377C1.92288 11.5985 1.90665 11.4418 1.90665 11.2812C1.90665 9.98889 2.95804 8.9375 4.2504 8.9375C5.01627 8.9375 5.69742 9.30676 6.1254 9.87659C6.55338 9.30676 7.23453 8.9375 8.0004 8.9375C8.76627 8.9375 9.44742 9.30676 9.8754 9.87659C10.3034 9.30676 10.9845 8.9375 11.7504 8.9375C13.0428 8.9375 14.0941 9.98889 14.0941 11.2812C14.0941 11.4418 14.0779 11.5985 14.047 11.75H15.5316C15.7906 11.75 16.0004 11.5402 16.0004 11.2812V9.40625C16.0004 8.63086 15.3695 8 14.5941 8Z"
        fill="white"
      />
      <path
        d="M5.65665 1.90625C5.65665 1.13086 5.02579 0.5 4.2504 0.5C3.47501 0.5 2.84415 1.13086 2.84415 1.90625C2.84415 2.68164 3.47501 3.3125 4.2504 3.3125C5.02579 3.3125 5.65665 2.68164 5.65665 1.90625Z"
        fill="white"
      />
      <path
        d="M9.40665 1.90625C9.40665 1.13086 8.77579 0.5 8.0004 0.5C7.22501 0.5 6.59415 1.13086 6.59415 1.90625C6.59415 2.68164 7.22501 3.3125 8.0004 3.3125C8.77579 3.3125 9.40665 2.68164 9.40665 1.90625Z"
        fill="white"
      />
      <path
        d="M13.1566 1.90625C13.1566 1.13086 12.5258 0.5 11.7504 0.5C10.975 0.5 10.3441 1.13086 10.3441 1.90625C10.3441 2.68164 10.975 3.3125 11.7504 3.3125C12.5258 3.3125 13.1566 2.68164 13.1566 1.90625Z"
        fill="white"
      />
      <path
        d="M2.37531 4.25C3.14117 4.25 3.82233 4.61926 4.25031 5.18909C4.67828 4.61926 5.35944 4.25 6.12531 4.25C6.89117 4.25 7.57233 4.61926 8.00031 5.18909C8.42828 4.61926 9.10944 4.25 9.87531 4.25C10.6412 4.25 11.3223 4.61926 11.7503 5.18909C12.1783 4.61926 12.8594 4.25 13.6253 4.25C13.7604 4.25 13.894 4.26196 14.0251 4.2843C13.8415 3.72095 13.3116 3.3125 12.6878 3.3125H10.8128C10.4529 3.3125 10.1243 3.44861 9.87531 3.67175C9.62628 3.44861 9.29767 3.3125 8.93781 3.3125H7.06281C6.70294 3.3125 6.37433 3.44861 6.12531 3.67175C5.87628 3.44861 5.54767 3.3125 5.18781 3.3125H3.31281C2.68878 3.3125 2.15863 3.72119 1.9754 4.28479C2.10541 4.26233 2.23895 4.25 2.37531 4.25Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_35_13247">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);
